module.exports = __webpack_public_path__ + "img/close.d9d41150.png";